import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { queryKeys } from '../lib/queryClient.js';

/**
 * "Signed in as …" line plus a sign-out link, shown at the top of the
 * Settings sheet. Almanac has no login screen of its own — Cloudflare
 * Access authenticates at the edge before the SPA ever loads — so this
 * is the only place the app tells you which account you're acting as.
 * That matters on a household-shared tool, where every write is
 * attributed to a user in the audit log.
 *
 * Sign-out points at the Access logout endpoint on this same origin,
 * which clears the Access session cookie. The next navigation re-runs
 * the Access flow, so the user can come back as themselves or as the
 * other household member.
 */
const ACCESS_LOGOUT_URL = '/cdn-cgi/access/logout';

export function AccountSection() {
  const me = useQuery({
    queryKey: queryKeys.me,
    queryFn: api.me,
    // Identity rarely changes within a session; don't refetch on every
    // settings open. A reload (which re-runs Access) is the refresh.
    staleTime: 1000 * 60 * 60,
  });

  return (
    <div className="reminder-toggle">
      <div className="reminder-toggle__label">
        <span className="reminder-toggle__heading">Account</span>
        <span className="reminder-toggle__status">
          {me.isLoading
            ? 'Checking…'
            : me.data
              ? `Signed in as ${me.data.email}`
              : 'Signed in.'}
        </span>
      </div>
      <div className="reminder-toggle__actions">
        <a className="btn btn--ghost btn--small" href={ACCESS_LOGOUT_URL}>
          Sign out
        </a>
      </div>
    </div>
  );
}
